import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import GroupJoinButton from '../groups/join-button';
import RequestJoinButton from './request-join-button'
import consumeAppContext from '../../consumers/app';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1, 0),
    '& > p': {
      margin: theme.spacing(1, 0)
    }
  }
}));

const JoinToggleMessage = ({ event, eventInvite, isLoggedIn, autoRsvp, onJoin, login }) => {
  const classes = useStyles();

  if (event.permissions.joinable && isLoggedIn) {
    return null;
  }

  // build returnTo
  let returnTo;
  if (!isLoggedIn) {
    const queryParams = [];
    if (autoRsvp) {
      queryParams.push(`rsvp=${autoRsvp}`);
    }
    if (eventInvite) {
      queryParams.push(`join=${eventInvite.id}`);
    }

    const query = queryParams.length ? `?${queryParams.join('&')}` : '';
    returnTo = `/events/${event.id}${query}`;
  }

  if (!eventInvite) {
    if (event.registrationType === 'APPROVAL_REQUIRED') {
      return (
        <div className={classes.wrapper}>
          <p>Host approval required to RSVP</p>
          <RequestJoinButton
            event={event}
            returnTo={returnTo}
            onJoin={onJoin}
          />
        </div>
      );
    }

    if (event.group && event.visibility !== 'PUBLIC') {
      return (
        <div className={classes.wrapper}>
          <p>Group membership required to RSVP</p>
          <GroupJoinButton
            group={event.group}
            onJoin={onJoin}
            returnTo={returnTo}
          />
        </div>
      );
    }
  }

  if (!isLoggedIn) {
    return (
      <div className={classes.wrapper}>
        <Button
          color="primary"
          variant="contained"
          onClick={(e) => {
            e.preventDefault();
            login(returnTo);
          }}
        >
          Log in to RSVP
        </Button>
      </div>
    );
  }

  return null;
};

JoinToggleMessage.propTypes = {
  event: PropTypes.object,
  eventInvite: PropTypes.object,
  autoRsvp: PropTypes.string,
  onJoin: PropTypes.func,
  login: PropTypes.func,
  isLoggedIn: PropTypes.bool
};

export default consumeAppContext(JoinToggleMessage);
